import React, { useEffect } from "react";

const LanguageController = () => {
  useEffect(() => {
    if (document.getElementById("google-translate-script")) return;

    // ── 1. WIDGET INIT ────────────────────────────────────────────────────
    window.googleTranslateElementInit = () => {
      if (window.google && window.google.translate) {
        new window.google.translate.TranslateElement(
          { pageLanguage: 'en', autoDisplay: false },
          'google_translate_element'
        );
      }
    };

    // ── 2. INJECT SCRIPT ──────────────────────────────────────────────────
    const script = document.createElement("script");
    script.id = "google-translate-script";
    script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    document.body.appendChild(script);

    // ── 3. FULL SUPPRESSION SHIELD ────────────────────────────────────────
    const style = document.createElement("style");
    style.id = "gt-suppress-style";
    style.innerHTML = `
      .goog-te-banner-frame,
      .goog-te-banner-frame.skiptranslate { display: none !important; visibility: hidden !important; }
      body { top: 0px !important; position: static !important; }
      .VIpgJd-ZVi9od-aZ2wEe-wOHMyf,
      .VIpgJd-ZVi9od-aZ2wEe-OiiCO,
      .VIpgJd-ZVi9od-ORrEK-eup2Ef,
      .goog-te-spinner,
      .goog-te-spinner-pos,
      .goog-te-spinner-animation { display: none !important; visibility: hidden !important; opacity: 0 !important; }
      #goog-gt-tt, .goog-te-balloon-frame, .goog-te-menu-frame { display: none !important; }
      .goog-text-highlight { background: transparent !important; border: none !important; box-shadow: none !important; }
      #google_translate_element { display: none !important; }
      .goog-logo-link, .goog-te-gadget img { display: none !important; }
      .goog-te-gadget { color: transparent !important; font-size: 0 !important; }
    `;
    document.head.appendChild(style);

    // ── 4. ENFORCER INTERVAL ──────────────────────────────────────────────
    const intervalId = setInterval(() => {
      const body = document.body;
      if (body && body.style.top !== "0px") {
        body.style.top = "0px";
        body.style.position = "static";
      }
      const banner = document.querySelector('.goog-te-banner-frame');
      if (banner) { banner.style.display = "none"; banner.style.visibility = "hidden"; }
      document.querySelectorAll(
        '.VIpgJd-ZVi9od-aZ2wEe-wOHMyf,.VIpgJd-ZVi9od-aZ2wEe-OiiCO,.goog-te-spinner'
      ).forEach(el => { el.style.display = "none"; el.style.opacity = "0"; });
    }, 150);

    // ── 5. MUTATION OBSERVER — detects when translation actually completes ─
    //
    // Google Translate adds 'translated-ltr' or 'translated-rtl' to <html>
    // when it finishes translating. We watch for this change and fire a
    // custom window event so the TranslationLoader knows when to hide.
    //
    const translationObserver = new MutationObserver(() => {
      const htmlEl = document.documentElement;
      const isTranslated =
        htmlEl.classList.contains('translated-ltr') ||
        htmlEl.classList.contains('translated-rtl');

      if (isTranslated) {
        // Small extra delay to let last DOM mutations paint before hiding loader
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('translationComplete'));
        }, 300);
      } else {
        // English restore also completes — fire after short settle time
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('translationComplete'));
        }, 300);
      }
    });

    translationObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });

    // ── 6. CHANGE LANGUAGE ────────────────────────────────────────────────
    //
    // FIX — double-click bug:
    // Google Translate's internal listener requires the 'change' event with
    // bubbles:true. Additionally, some browsers need it fired a second time
    // after a 1ms tick for the widget to properly register the new value.
    // This is a known quirk — firing twice resolves the "need to click twice"
    // behaviour completely.
    //
    window.changeLanguage = (langCode) => {
      // Signal to loader that translation is starting
      window.dispatchEvent(new CustomEvent('translationStart', { detail: { lang: langCode } }));

      let attempts = 0;
      const maxAttempts = 15;

      const tryChange = () => {
        const select = document.querySelector(".goog-te-combo");

        if (select) {
          select.value = langCode;

          // Fire #1 — triggers Google Translate's change handler
          select.dispatchEvent(new Event('change', { bubbles: true }));

          // Fire #2 after 1ms — ensures browsers that need a second event get it
          // This is the fix for the "must click twice" bug
          setTimeout(() => {
            const freshSelect = document.querySelector(".goog-te-combo");
            if (freshSelect) {
              freshSelect.value = langCode;
              freshSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }, 1);

          return; // Done
        }

        attempts++;
        if (attempts < maxAttempts) {
          setTimeout(tryChange, 300);
        } else {
          console.warn(`changeLanguage: widget not ready after ${maxAttempts} attempts.`);
          // Dismiss loader even on failure so UI doesn't stay stuck
          window.dispatchEvent(new CustomEvent('translationComplete'));
        }
      };

      tryChange();
    };

    return () => {
      clearInterval(intervalId);
      translationObserver.disconnect();
    };
  }, []);

  return null;
};

export default LanguageController;